{
  "nav": {
    "layers": "レイヤー",
    "discover": "発見",
    "random": "ランダム記事",
    "configuration": "設定",
    "settings": "設定",
    "pro": "PROバージョン",
    "collections": "コレクション",
    "play": "再生",
    "help": "ヘルプ",
    "logout": "ログアウト",
    "community": "コミュニティ掲示板",
    "account": "アカウント管理"
  },
  "auth": {
    "signIn": "ログイン",
    "signUp": "新規登録",
    "signingIn": "ログイン中...",
    "creatingAccount": "アカウント作成中...",
    "email": "メールアドレス",
    "password": "パスワード",
    "username": "ユーザー名",
    "or": "または",
    "noAccount": "アカウントをお持ちでないですか？",
    "hasAccount": "すでにアカウントをお持ちですか？",
    "loginFailed": "ログインに失敗しました。認証情報をご確認ください。",
    "signupFailed": "登録に失敗しました。もう一度お試しください。"
  },
  "map": {
    "loading": "地図を読み込み中...",
    "ruler": "支配者",
    "culture": "文化",
    "religion": "宗教",
    "religionGeneral": "宗教（一般）",
    "capital": "首都",
    "population": "人口"
  },
  "layers": {
    "title": "レイヤー",
    "general": "一般",
    "advanced": "詳細設定",
    "area": "エリア",
    "label": "ラベル",
    "markers": "マーカー",
    "epics": "叙事詩",
    "migration": "移住",
    "basemap": "ベースマップ",
    "showProvinces": "州を表示",
    "opacityByPopulation": "人口による不透明度",
    "clusterMarkers": "マーカーのクラスター化",
    "markerLimit": "マーカーの上限",
    "uncheckAll": "すべて解除",
    "checkAll": "すべて選択",
    "suggestions": "お使いのデバイスに基づく提案...",
    "markerTypes": {
      "artifact": "遺物",
      "battle": "戦闘",
      "siege": "包囲戦",
      "capital": "首都",
      "city": "都市",
      "castle": "城",
      "landmark": "ランドマーク",
      "military": "軍人",
      "politician": "政治家",
      "explorer": "探検家",
      "scientist": "科学者",
      "artist": "芸術家",
      "religious": "宗教家",
      "athlete": "アスリート",
      "unclassified": "未分類",
      "unknown": "不明"
    },
    "basemapTypes": {
      "topographic": "地形図",
      "satellite": "Satellite",
      "light": "Light",
      "none": "なし"
    },
    "mapLabels": "地図ラベル",
    "labelModes": {
      "historical": "歴史的名称",
      "modern": "現代名",
      "both": "両方"
    },
    "epicTypes": {
      "wars": "戦争",
      "empires": "帝国",
      "religion": "宗教",
      "culture": "文化",
      "people": "人物",
      "other": "その他"
    }
  },
  "settings": {
    "title": "設定",
    "theme": "テーマ",
    "language": "言語",
    "fullscreen": "全画面",
    "toggle": "切替",
    "fontType": "フォント",
    "markerType": "マーカータイプ",
    "themes": {
      "light": "ライト",
      "dark": "ダーク",
      "luther": "Luther"
    }
  },
  "timeline": {
    "expandTimeline": "タイムラインを展開",
    "collapseTimeline": "タイムラインを折りたたむ",
    "resetView": "タイムライン表示をリセット",
    "searchEpics": "叙事詩を検索",
    "autoplay": "自動再生を開始",
    "stopAutoplay": "自動再生を停止",
    "autoplayTitle": "自動再生",
    "autoplaySubtitle": "ステップサイズごとに年を変更",
    "startYear": "開始年",
    "endYear": "終了年",
    "stepSize": "年単位のステップサイズ",
    "delay": "秒単位の遅延",
    "repeat": "繰り返し",
    "startSlideshow": "スライドショーを開始"
  },
  "drawer": {
    "noContent": "コンテンツが選択されていません",
    "closePanel": "パネルを閉じる",
    "provinceDataNotAvailable": "この選択に対する州データは利用できません。"
  },
  "common": {
    "loading": "読み込み中...",
    "close": "閉じる",
    "cancel": "キャンセル",
    "save": "保存",
    "edit": "編集",
    "delete": "削除",
    "back": "戻る",
    "ad": "年",
    "bc": "紀元前"
  }
}
